import { render, staticRenderFns } from "./xiti-select.vue?vue&type=template&id=34a18ff3&scoped=true&"
import script from "./xiti-select.vue?vue&type=script&lang=ts&"
export * from "./xiti-select.vue?vue&type=script&lang=ts&"
import style0 from "./xiti-select.vue?vue&type=style&index=0&id=34a18ff3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a18ff3",
  null
  
)

export default component.exports